import styled from 'styled-components';
import { alignItems, compose, flexDirection, flexWrap, justifyContent } from 'styled-system';
import { Box } from '../Box/Box';
import { applyVariations } from '../utils/utils';
/**
 * @public
 */
export const Flex = /*#__PURE__*/styled(Box).attrs(({
  wrap,
  align,
  justify,
  ...props
}) => ({
  flexWrap: wrap ? 'wrap' : undefined,
  alignItems: align,
  justifyContent: justify,
  ...props
})).withConfig({
  displayName: "Flex",
  componentId: "sc-1yrtwh8-0"
})(["display:flex;", " ", ""], applyVariations('Flex'), props => compose(alignItems, justifyContent, flexDirection, flexWrap)(props));